import Box from '@mui/material/Box'
import { DashboardMenuItem, MenuItemLink, useGetIdentity, useSidebarState } from 'react-admin'
import ListIcon from '@mui/icons-material/List'
import OutboxIcon from '@mui/icons-material/Outbox';
import { Divider } from '@mui/material'
import { ShoppingBagOutlined } from '@mui/icons-material'
import NotificationsIcon from '@mui/icons-material/Notifications'
import { useProviderContext } from '../context/ProviderContext'

const Menu = () => {
  const [open] = useSidebarState()
  const { providerInfo } = useProviderContext()
  const { identity } = useGetIdentity()

  // eslint-disable-next-line no-unused-vars
  const hasKitRequestsAccess =
    !!providerInfo.kitRequestsEnabled ||
    !!identity?.kitRequests ||
    localStorage.getItem('provider_portal_kit_requests') === 'true'

  return (
    <Box
      sx={{
        width: open ? '100%' : 50,
        marginTop: 1,
        marginBottom: 1,
        height: '100%',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
        transition: (theme) =>
          theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <DashboardMenuItem />
      <MenuItemLink
        to="provider-portal/providers"
        state={{ _scrollToTop: true }}
        primaryText={`Results`}
        leftIcon={<ListIcon />}
      />
      <MenuItemLink
        to="provider-portal/bulk-orders"
        state={{ _scrollToTop: true }}
        primaryText={`Bulk Orders`}
        leftIcon={<ShoppingBagOutlined />}
      />
      <MenuItemLink
        to="provider-portal/kit-requests"
        state={{ _scrollToTop: true }}
        primaryText={`Kit Requests`}
        leftIcon={<OutboxIcon />}
      />
      <MenuItemLink
        to="provider-portal/notification-settings"
        state={{ _scrollToTop: true }}
        primaryText={`Notification Settings`}
        leftIcon={<NotificationsIcon />}
      />
      <Divider />
    </Box>
  )
}

export default Menu
